var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled from 'styled-components';
import { designSchema } from '../../../contexts/designs/utils';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n\n  ", "\n"], ["\n  display: block;\n\n  ", "\n"])), designSchema);
export var Text = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  ", ";\n"], ["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  ", ";\n"])), function (_a) {
    var isTruncated = _a.isTruncated;
    return isTruncated && '-webkit-line-clamp: 2';
});
export var FakeLink = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: var(--link-color);\n"], ["\n  color: var(--link-color);\n"])));
var templateObject_1, templateObject_2, templateObject_3;
